module.exports = __webpack_public_path__ + "img/video-detection-success.125a535a.png";